import { Link } from "react-router-dom";
import { Reveal } from "@/lib/motion";
import NewsletterForm from "@/components/site/NewsletterForm";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#1A1A1A] text-[#EAE7E0] relative overflow-hidden" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 pt-24 pb-10">
        <Reveal>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 border-b border-white/10 pb-16">
            <div className="md:col-span-6">
              <div className="font-grotesk text-[11px] uppercase tracking-[0.28em] text-white/50 mb-6">
                — Build with intention
              </div>
              <h3 className="font-display text-4xl md:text-6xl leading-[0.95] tracking-tight">
                Let’s design the next <em className="hero-italic">landmark</em> together.
              </h3>
              <div className="mt-8 flex flex-wrap items-center gap-6">
                <Link
                  to="/contact"
                  className="btn-sharp"
                  style={{ background: "#FAF9F6", color: "#1A1A1A" }}
                  data-testid="footer-cta"
                >
                  <span>Begin an Enquiry</span>
                  <span aria-hidden>→</span>
                </Link>
                <Link
                  to="/quote"
                  className="btn-ghost"
                  style={{ color: "#FAF9F6", borderColor: "#FAF9F6" }}
                  data-testid="footer-quote"
                >
                  <span>Free Quote</span>
                  <span>→</span>
                </Link>
              </div>

              <div className="mt-14 max-w-md">
                <div className="font-grotesk text-[10px] uppercase tracking-[0.28em] text-white/40 mb-3">
                  Studio Dispatch — quarterly, no spam
                </div>
                <NewsletterForm source="footer" />
              </div>
            </div>

            <div className="md:col-span-2">
              <div className="font-grotesk text-[10px] uppercase tracking-[0.28em] text-white/40 mb-4">
                Studio
              </div>
              <ul className="space-y-2 font-grotesk text-sm">
                <li><Link to="/projects" className="link-under">Portfolio</Link></li>
                <li><Link to="/contact" className="link-under">Contact</Link></li>
              </ul>
            </div>

            <div className="md:col-span-2">
              <div className="font-grotesk text-[10px] uppercase tracking-[0.28em] text-white/40 mb-4">
                Contact
              </div>
              <ul className="space-y-2 font-grotesk text-sm text-white/80">
                <li>London, Ontario</li>
                <li>
                  <a href="tel:+15197029417" className="link-under" data-testid="footer-phone">
                    +1 519-702-9417
                  </a>
                </li>
                <li>
                  <a href="mailto:Yachconstruction1@gmail.com" className="link-under" data-testid="footer-email">
                    Yachconstruction1@gmail.com
                  </a>
                </li>
              </ul>
            </div>

            <div className="md:col-span-2">
              <div className="font-grotesk text-[10px] uppercase tracking-[0.28em] text-white/40 mb-4">
                Hours
              </div>
              <ul className="space-y-2 font-grotesk text-sm text-white/80">
                <li>Mon–Fri · 08:00 – 18:00</li>
                <li>Sat · By Appointment</li>
                <li>Sun · Closed</li>
              </ul>
            </div>
          </div>
        </Reveal>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-10 font-grotesk text-[11px] uppercase tracking-[0.24em] text-white/40">
          <div>© {year} Yach Construction Inc. — All rights reserved.</div>
          <div className="flex items-center gap-6">
            <span>Licensed & Insured</span>
            <span>Ontario, Canada</span>
            <Link to="/admin" className="link-under" data-testid="footer-admin">Admin</Link>
          </div>
        </div>
      </div>

      {/* Editorial giant logo watermark */}
      <div className="pointer-events-none select-none px-6 md:px-10 pb-6 flex justify-center">
        <img
          src="https://customer-assets-gfyr7b9c.emergentagent.net/job_build-vessel/artifacts/2iaunrlz_YACH_Construction_Print_HighRes_300DPI.webp"
          alt=""
          className="w-[90vw] md:w-[70vw] opacity-[0.12]"
        />
      </div>
    </footer>
  );
}
